import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlider = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M1.75 3.75h12.5m0 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM1.75 10H4m0 0a2 2 0 1 0 4 0m-4 0a2 2 0 1 1 4 0m0 0h10.25m-16.5 6.25h8m0 0a2 2 0 1 0 4 0m-4 0a2 2 0 1 1 4 0m0 0h4.5"
	})]
});
const ForwardRef = forwardRef(SvgSlider);
export { ForwardRef as ReactComponent };
